import React, { ReactElement } from 'react'
import { Product as IProduct } from '../../interfaces/definitions/product.interface'
import { Link } from 'react-router-dom'
import './Product.css'

interface Props {
  product: IProduct
}

export const Product = (props: Props): ReactElement => {
  const { product } = props
  return (
    <Link className='product-link' to={`/products/${product.id}`}>
      <div className='product-div'>
        <span className='product-name'>{product.name}</span>
        <span className={`product-label ${product.currentStep.toLowerCase()}`}> {product.currentStep} </span>
      </div>
    </Link>
  )
}
